(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["it-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function today() {
      var d = new Date();
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    function setup(root) {
      if (!root || root.dataset.itAnnReady) return;
      root.dataset.itAnnReady = '1';
      var t = today();
      var msgs = Array.prototype.slice.call(root.querySelectorAll('.it-ann__msg')).filter(function (m) {
        var until = m.getAttribute('data-it-until');
        if (until && t > until) { m.hidden = true; m.classList.remove('is-active'); return false; }
        return true;
      });
      if (!msgs.length) { root.hidden = true; return; }
      if (!msgs.some(function (m) { return m.classList.contains('is-active'); })) {
        msgs[0].classList.add('is-active'); msgs[0].removeAttribute('aria-hidden');
      }
      if (msgs.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = msgs.findIndex(function (m) { return m.classList.contains('is-active'); });
      var paused = false;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      var interval = parseInt(root.dataset.interval, 10) || 4500;
      root._itTimer = setInterval(function () {
        if (paused || document.hidden) return;
        var cur = msgs[i];
        i = (i + 1) % msgs.length;
        var next = msgs[i];
        cur.classList.remove('is-active'); cur.classList.add('is-leaving'); cur.setAttribute('aria-hidden', 'true');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 450);
        next.classList.add('is-active'); next.removeAttribute('aria-hidden');
      }, interval);
    }
    function init() { document.querySelectorAll('[data-it-ann]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-it-ann]');
      if (el) { if (el._itTimer) clearInterval(el._itTimer); delete el.dataset.itAnnReady; setup(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-collection-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function headerOffset() {
      var h = document.querySelector('.m-header__wrapper, .m-header, header');
      return (h ? h.getBoundingClientRect().height : 0) + 16;
    }
    function initSubs(nav) {
      if (!nav || nav.dataset.itReady) return;
      nav.dataset.itReady = '1';
      var track = nav.querySelector('[data-it-subs-track]');
      var prev = nav.querySelector('[data-it-subs-prev]');
      var next = nav.querySelector('[data-it-subs-next]');
      if (!track || !prev || !next) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var canPrev = track.scrollLeft > 2;
        var canNext = track.scrollLeft < max;
        prev.hidden = !canPrev;
        next.hidden = !canNext;
        nav.classList.toggle('has-prev', canPrev);
        nav.classList.toggle('has-next', canNext);
      }
      function step(dir) {
        track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.7, 200), behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      var active = track.querySelector('.is-active');
      if (active && active.parentElement) {
        var li = active.parentElement;
        var left = li.offsetLeft - track.clientWidth / 2 + li.clientWidth / 2;
        if (left > 0) track.scrollLeft = left;
      }
      update();
    }
    function initMore(root) {
      root.querySelectorAll('[data-it-more]').forEach(function (link) {
        if (link.dataset.itReady) return;
        link.dataset.itReady = '1';
        link.addEventListener('click', function (e) {
          var target = document.getElementById('it-collection-info');
          if (!target) return;
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      });
    }
    function init(root) {
      root = root || document;
      root.querySelectorAll('[data-it-subs]').forEach(initSubs);
      initMore(root);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCountdown(root) {
      var el = root.querySelector('[data-it-countdown]');
      if (!el) return;
      var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec((el.dataset.deadline || '').trim());
      if (!match) return;
      var end = new Date(+match[1], +match[2] - 1, +match[3], 23, 59, 59);
      var days = Math.ceil((end - new Date()) / 86400000);
      if (days < 1) return; /* deadline passed: keep the eyebrow text */
      var text = days === 1 ? el.dataset.lastDay : (el.dataset.template || '').replace('[days]', days);
      if (text) el.textContent = text;
    }
    function initAll() {
      document.querySelectorAll('.it-hero').forEach(initCountdown);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.it-hero');
      if (root) initCountdown(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-product-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(card) {
      if (!card || card.dataset.itDescReady) return;
      card.dataset.itDescReady = '1';
      var content = card.querySelector('[data-it-desc-content]');
      var btn = card.querySelector('[data-it-desc-more]');
      if (!content || !btn) return;
      var label = btn.querySelector('[data-it-desc-label]');
      var moreText = label ? label.textContent : 'Read more';
      var fold = parseInt(getComputedStyle(content).getPropertyValue('--it-fold'), 10) || 560;
      if (content.scrollHeight <= fold + 120) return;
      card.classList.add('is-folded');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (open) {
          card.classList.add('is-folded');
          btn.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = moreText;
          var top = card.getBoundingClientRect().top + window.pageYOffset - 140;
          if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
          card.classList.remove('is-folded');
          btn.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = 'Show less';
        }
      });
    }
    function init() { document.querySelectorAll('[data-it-desc]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateArrows(root) {
      var track = root.querySelector('[data-it-recs-track]');
      var prev = root.querySelector('[data-it-recs-prev]');
      var next = root.querySelector('[data-it-recs-next]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      root.classList.toggle('is-static', max <= 0);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function bind(root) {
      if (root.dataset.itRecsBound) return;
      root.dataset.itRecsBound = '1';
      var track = root.querySelector('[data-it-recs-track]');
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-it-recs-prev], [data-it-recs-next]');
        if (!btn) return;
        var item = track.querySelector('.it-recs__item');
        var step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
        track.scrollBy({ left: (btn.hasAttribute('data-it-recs-prev') ? -1 : 1) * step, behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () { updateArrows(root); }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(root); });
    }
    function load(root) {
      if (!root || root.dataset.itRecsReady) return;
      root.dataset.itRecsReady = '1';
      var track = root.querySelector('[data-it-recs-track]');
      if (track.children.length) { root.hidden = false; bind(root); updateArrows(root); return; }
      fetch(root.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-it-recs-track]');
          if (!fresh || !fresh.children.length) return;
          track.innerHTML = fresh.innerHTML;
          root.hidden = false;
          bind(root);
          updateArrows(root);
        })
        .catch(function () {});
    }
    function initAll() { document.querySelectorAll('[data-it-recs]').forEach(load); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-it-recs]'); if (el) { delete el.dataset.itRecsReady; delete el.dataset.itRecsBound; load(el); } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-product-style"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(pence) {
      var whole = Math.floor(pence / 100);
      return '£' + whole.toLocaleString('en-GB');
    }
    function readPrices(root) {
      var el = root.querySelector('[data-it-variant-prices]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }
    function currentVariantId(root) {
      var input = root.querySelector('.main-product__block-buy_buttons form [name="id"]') || root.querySelector('form[action*="/cart/add"] [name="id"]');
      return input ? String(input.value) : '';
    }
    function refresh(root) {
      var prices = readPrices(root);
      var id = currentVariantId(root);
      if (!prices || !id || !prices[id]) return;
      var p = prices[id];
      var save = root.querySelector('[data-it-save]');
      if (save) {
        var diff = p.compare > p.price ? Math.floor((p.compare - p.price) / 100) * 100 : 0;
        save.hidden = diff < 100;
        var amount = save.querySelector('[data-it-save-amount]');
        if (amount && diff >= 100) amount.textContent = money(diff);
      }
      var facts = root.querySelector('[data-it-facts]');
      if (facts) {
        var from = parseInt(facts.dataset.freeFrom, 10) || 10000;
        var free = facts.querySelector('[data-it-free]');
        var paid = facts.querySelector('[data-it-paid]');
        if (free && paid) { free.hidden = p.price < from; paid.hidden = p.price >= from; }
      }
    }
    function expire(root) {
      var d = new Date();
      var today = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      root.querySelectorAll('[data-it-until]').forEach(function (el) {
        if (today > el.getAttribute('data-it-until')) el.hidden = true;
      });
    }
    /* ---- Working-day delivery estimate (snippets/it-delivery-estimate.liquid) ---- */
    var HOLS_KEY = 'it-uk-bank-holidays';
    function londonNow() {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour, minute: +parts.minute };
    }
    function iso(d) { return d.toISOString().slice(0, 10); }
    function addDay(d) { return new Date(d.getTime() + 86400000); }
    function isWorking(d, hols) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !hols[iso(d)]; }
    function estimate(days, cutoff, hols) {
      var now = londonNow();
      var start = now.date;
      var beforeCutoff = isWorking(start, hols) && now.hour < cutoff;
      if (!beforeCutoff) { do { start = addDay(start); } while (!isWorking(start, hols)); }
      var d = start, n = 0;
      while (n < days) { d = addDay(d); if (isWorking(d, hols)) n++; }
      var left = beforeCutoff ? (cutoff * 60) - (now.hour * 60 + now.minute) : 0;
      return { date: d, beforeCutoff: beforeCutoff, minutesLeft: left };
    }
    function renderEta(el, hols) {
      var days = parseInt(el.dataset.days, 10) || 3;
      var cutoff = parseInt(el.dataset.cutoff, 10) || 12;
      var r = estimate(days, cutoff, hols);
      var out = el.querySelector('[data-it-eta-date]');
      var note = el.querySelector('[data-it-eta-note]');
      if (out) out.textContent = r.date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).replace(',', '');
      if (note) {
        if (r.beforeCutoff && r.minutesLeft > 0) {
          var h = Math.floor(r.minutesLeft / 60), m = r.minutesLeft % 60;
          var parts = [];
          if (h) parts.push(h + (h === 1 ? ' hr' : ' hrs'));
          if (m || !h) parts.push(m + (m === 1 ? ' min' : ' mins'));
          note.innerHTML = 'Order within <b>' + parts.join(' ') + '</b>';
        } else {
          note.textContent = el.dataset.note || '';
        }
      }
      el.hidden = false;
    }
    function holidaySet(list) { var h = {}; (list || []).forEach(function (d) { h[d] = true; }); return h; }
    function initEta(root) {
      var el = root.querySelector('[data-it-eta]');
      if (!el) return;
      var fallback = [];
      var fb = root.querySelector('[data-it-eta-holidays]');
      if (fb) { try { fallback = JSON.parse(fb.textContent); } catch (e) {} }
      var cached = null;
      try { cached = JSON.parse(localStorage.getItem(HOLS_KEY) || 'null'); } catch (e) {}
      var list = fallback.concat(cached && cached.dates ? cached.dates : []);
      el._itHols = holidaySet(list);
      renderEta(el, el._itHols);
      if (!el._itTimer) el._itTimer = setInterval(function () { renderEta(el, el._itHols); }, 60000);
      if (cached && cached.at && Date.now() - cached.at < 7 * 86400000) return;
      fetch('https://www.gov.uk/bank-holidays.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j['england-and-wales']) return;
          var dates = j['england-and-wales'].events.map(function (e) { return e.date; });
          try { localStorage.setItem(HOLS_KEY, JSON.stringify({ at: Date.now(), dates: dates })); } catch (e) {}
          el._itHols = holidaySet(fallback.concat(dates));
          renderEta(el, el._itHols);
        })
        .catch(function () {});
    }
    /* ---- Thumbnail arrows (only when there are more thumbnails than fit) ---- */
    function initThumbArrows() {
      var wrap = document.querySelector('.m-product-media--slider__thumbnails');
      var container = wrap && wrap.querySelector('.nav-swiper-container');
      var sw = container && container.swiper;
      if (!sw) { if (wrap && !wrap._itTries) { wrap._itTries = 0; } if (wrap && wrap._itTries++ < 20) setTimeout(initThumbArrows, 250); return; }
      if (wrap.querySelector('.it-thumb-arrow')) return;
      var icon = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
      var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'it-thumb-arrow it-thumb-arrow--prev'; prev.setAttribute('aria-label', 'Previous images'); prev.innerHTML = icon('M15 5l-7 7 7 7');
      var next = document.createElement('button'); next.type = 'button'; next.className = 'it-thumb-arrow it-thumb-arrow--next'; next.setAttribute('aria-label', 'More images'); next.innerHTML = icon('M9 5l7 7-7 7');
      wrap.appendChild(prev); wrap.appendChild(next);
      var step = function () { return Math.max(1, Math.floor(sw.params.slidesPerView || 1) - 1); };
      prev.addEventListener('click', function () { sw.slideTo(Math.max(0, sw.activeIndex - step())); });
      next.addEventListener('click', function () { sw.slideTo(Math.min(sw.slides.length - 1, sw.activeIndex + step())); });
      var update = function () { prev.hidden = sw.isBeginning; next.hidden = sw.isEnd; };
      sw.on('slideChange', update); sw.on('progress', update); sw.on('resize', update);
      update();
    }
    function init() {
      var root = document.querySelector('.m-main-product--info');
      if (!root) return;
      expire(root);
      initEta(root);
      initThumbArrows();
      if (root.dataset.itPdp) return;
      root.dataset.itPdp = '1';
      root.addEventListener('change', function () {
        requestAnimationFrame(function () { setTimeout(function () { refresh(root); }, 60); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["it-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'minimog-recently-viewed';
    function readIds() {
      try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function updateArrows(root) {
      var track = root.querySelector('[data-it-rv-track]');
      var prev = root.querySelector('[data-it-rv-prev]');
      var next = root.querySelector('[data-it-rv-next]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      root.classList.toggle('is-static', max <= 0);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function bind(root) {
      var track = root.querySelector('[data-it-rv-track]');
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-it-rv-prev], [data-it-rv-next]');
        if (btn) {
          var item = track.querySelector('.it-rv__item');
          var step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
          track.scrollBy({ left: (btn.hasAttribute('data-it-rv-prev') ? -1 : 1) * step, behavior: 'smooth' });
          return;
        }
        if (e.target.closest('[data-it-rv-clear]')) {
          try { window.localStorage.removeItem(KEY); } catch (err) {}
          root.hidden = true;
        }
      });
      track.addEventListener('scroll', function () { updateArrows(root); }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(root); });
    }
    function load(root) {
      if (!root || root.dataset.itRvReady) return;
      root.dataset.itRvReady = '1';
      var limit = parseInt(root.dataset.limit, 10) || 8;
      var current = parseInt(root.dataset.current, 10);
      var ids = readIds().filter(function (id) { return id && id !== current; });
      if (!ids.length) return;
      ids = ids.slice(0, 24);
      var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?section_id=it-recently-viewed&type=product&q=' + encodeURIComponent(q);
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = Array.prototype.slice.call(doc.querySelectorAll('.it-rv__item'));
          if (!items.length) return;
          var byId = {};
          items.forEach(function (li) { byId[li.getAttribute('data-product-id')] = li; });
          var track = root.querySelector('[data-it-rv-track]');
          track.innerHTML = '';
          var shown = 0;
          ids.forEach(function (id) {
            var li = byId[String(id)];
            if (!li || shown >= limit) return;
            var card = li.querySelector('.it-card');
            if (card) {
              card.className = card.className.replace(/it-card--(yellow|blue|green|peach|lilac)/, 'it-card--' + ['yellow', 'blue', 'green', 'peach', 'lilac'][shown % 5]);
            }
            track.appendChild(document.importNode(li, true));
            shown++;
          });
          if (!shown) return;
          root.hidden = false;
          bind(root);
          updateArrows(root);
        })
        .catch(function () {});
    }
    function initAll() { document.querySelectorAll('[data-it-rv]').forEach(load); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-it-rv]'); if (el) { delete el.dataset.itRvReady; load(el); } });
  })();

  } catch(e) { console.error(e); }
})();
})();
